export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/menu-a73a2486870402531d4ce4f3a3b37794.svg";